export default "__VITE_PUBLIC_ASSET__e035304d__"